import { Label } from "../../../core/render/Label";
/**
 * Draws an axis label.
 *
 * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/axes/#Labels} for more info
 * @important
 */
export class AxisLabel extends Label {
    constructor() {
        super(...arguments);
        this._tickPoints = [];
    }
}
AxisLabel.className = "AxisLabel";
AxisLabel.classNames = Label.classNames.concat([AxisLabel.className]);
//# sourceMappingURL=AxisLabel.js.map